import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../css/bootstrap.css";
import "../css/style-min.css";
import "../css/responsive-min.css";
// import "../css/style.css";
// import "../css/responsive.css";
import logo from "../images/logo.webp";
import Phn from "../images/phone.webp";
import menu from "../images/menu.webp";
import $ from "jquery";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
    mobileNo:
      (this.props.serviceStation)
        ? this.props.serviceStation.mobileNo
        : "",
  };
}
  menuClick() {
    $(".menulist").addClass("menulist-active");
  }
  menuClose() {
    $(".menulist").removeClass("menulist-active");
  }
  render() {
    return (
      <header className="header">
        <nav  role="navigation"  aria-label="main navigation" className="header-nav">
          <div className="container header-nav-container">
            <div className="menuIcon" onClick={() => this.menuClick()}>
                  {/* <img src={menu} alt="menu" className="menuimg"
                    width="44"
                    height="20" /> */}
                    
                <div className="menubar__icon menuimg">
                  <div className="menubar__icon01"></div>
                  <div className="menubar__icon01"></div>
                  <div className="menubar__icon01"></div>
                </div>
              </div>
              <div className="logo" title="AXIS BANK">
                <a href="/">
                  <img src={logo} alt="logo" className="iocl-logo" width="189" height="45" />
                </a>
              </div>
                {/* <p className="pull-right transalte">Translate</p> */}
              <div className="menulist">
                  <div className="menuClose" onClick={() => this.menuClose()}>×</div>
                  <ul className="menulist-ul">
                      <li className="menulist-li">
                        <a href="https://www.axisbank.com/?utm_source=branch-atm-locator&utm_medium=branch-locator&_ga=2.47930151.1473191904.1665123386-479982798.1665123386" target="_blank" rel="noopener noreferrer">Home</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axisbank.com/retail?cta=branch-explore-products&_ga=2.48855974.1473191904.1665123386-479982798.1665123386" target="_blank" rel="noopener noreferrer">Explore Products</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axisbank.com/grab-deals/online-offers?cta=branch-grab-deals&_ga=2.48855974.1473191904.1665123386-479982798.1665123386" target="_blank" rel="noopener noreferrer">Grab Deals</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axisbank.com/explore-make-payments?cta=branch-make-payment&_ga=2.48855974.1473191904.1665123386-479982798.1665123386" target="_blank" rel="noopener noreferrer">Make Payment</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axisbank.com/bank-smart/internet-banking/getting-started?cta=branch-bank-smart&_ga=2.48855974.1473191904.1665123386-479982798.1665123386x" target="_blank" rel="noopener noreferrer">Bank Smart</a>
                      </li>
                      <li className="menulist-li menulist-liMob">
                        {/* {this.state.mobileNo !== "" && ( */}
                            <>
                            <img
                              src={Phn}
                              className="head-phn"
                              alt="Phn"
                              width="44"
                              height="20"
                            />
                            <a className="phn-txt" href={ "tel:18002333555" }> 18604195555</a>
                            </>
                        {/* )}{" "} */}
                      </li>
                    </ul>
              </div> 
          </div>
        </nav>
      </header>
    );
  }
}
export default Header;
